module.exports = __webpack_public_path__ + "img/img-bm-yes.004770ec.png";